import api from "../api/axiosInstance";

const scanLogService = {
  getAll: (params) => api.get("/scan-logs", { params }),
};

export default scanLogService;
